import React from 'react';

const CurrencyInput = ({
    value,
    onChange,
    placeholder = "Valor",
    style = {},
    ...props
}) => (
    <div style={{
        position: 'relative',
        width: '90%',        
        marginTop: '10px',
        // marginBottom: '20px',
        ...style
    }}>
        <span
            style={{
                position: 'absolute',
                left: '12px',
                top: '45%',
                transform: 'translateY(-50%)',
                color: '#4654A3',
                fontSize: '26px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                zIndex: 2
            }}
        >
            <img
                src="/images/simulator/dollar_minimalistic.svg"
                width="20"
                alt="Home"
            />
        </span>
        <input
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={{
                width: '100%',
                height: '44px',
                borderRadius: '8px',
                border: '1px solid #DEDEDE',
                background: '#fff',
                padding: '0 16px 0 44px',
                fontSize: '16px',
                outline: 'none'
            }}
            {...props}
        />
    </div>
);

export default CurrencyInput;